const initials = "feedback/";

export const UPDATE_FEEDBACK = `${initials}UPDATE_FEEDBACK`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;